import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  construccion: z.enum(['Indoor', 'Outdoor'], { message: 'Selecciona la construcción' }),
  tiempoUso: z.union([
    z.literal(''),
    z.coerce.number().int('El tiempo de uso debe ser entero').min(1, 'El tiempo de uso debe ser mayor a 0')
  ]).optional(),
  sucursales: z.object({
    value: z.string().min(1),
    label: z.string()
  }, { message: 'Debes seleccionar una sucursal' }).nullable().refine(Boolean, 'Debes seleccionar una sucursal'),
  multiImagenes: z.array(z.object({
    nombre: z.string()
  })).optional(),
});
